import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Shared hook for birthdays-this-week data.
 * Auto-fetches once when the user role qualifies (super_admin / hr /
 * senior_management / hod). Refreshes every 30 min while tab open.
 */
export function useBirthdaysThisWeek(user) {
  const [data, setData] = useState({ rows: [], count: 0, today: "" });
  const [loading, setLoading] = useState(false);

  const eligible = !!user && ["super_admin", "hr", "senior_management", "hod"].includes(user.role);

  useEffect(() => {
    if (!eligible) return;
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      try {
        const { data: d } = await api.get("/birthdays/this-week");
        if (!cancelled) setData(d);
      } catch { /* silent */ }
      finally { if (!cancelled) setLoading(false); }
    };
    load();
    const id = setInterval(load, 30 * 60 * 1000);
    return () => { cancelled = true; clearInterval(id); };
  }, [eligible]);

  return { ...data, loading, eligible };
}

/**
 * Build a WhatsApp wish link (wa.me) for a given employee.
 */
export function buildBirthdayWaLink(emp) {
  const digits = String(emp?.mobile || "").replace(/\D/g, "");
  let e164 = digits;
  if (digits.length === 10) e164 = `91${digits}`;
  else if (digits.length === 11 && digits.startsWith("0")) e164 = `91${digits.slice(1)}`;
  if (!e164 || e164.length < 10) return null;
  const firstName = (emp?.name || "").split(" ")[0] || emp?.name || "";
  const msg = `Happy Birthday ${firstName}! 🎂🎉\n\nWishing you a wonderful year ahead.\n\n— Team Bravura Packers`;
  return `https://wa.me/${e164}?text=${encodeURIComponent(msg)}`;
}

/**
 * Helper to print a friendly day label.
 */
export function birthdayDayLabel(daysUntil) {
  if (daysUntil === 0) return "Today";
  if (daysUntil === 1) return "Tomorrow";
  return `In ${daysUntil} days`;
}
